import { PageHero } from "@/components/site/PageHero";
import { FadeUp, Eyebrow } from "@/components/site/Motion";
import { FlagRow } from "@/components/site/Flags";
import { EnquiryForm } from "@/components/site/EnquiryForm";
import { OpenTag } from "@/components/site/OpenTag";
import { WINGS, US_ADDRESS, INDIA_ADDRESS } from "@/lib/site";
import { HeroCard } from "@/components/site/HeroCard";

const Office = ({ wing, flags, label, children, tone, testid, className = "" }) => (
  <FadeUp className={`flex flex-col justify-between gap-10 p-7 sm:p-10 ${tone} ${className}`} data-testid={testid}>
    <div className="flex flex-wrap items-center justify-between gap-3">
      <div className="flex items-center gap-3"><FlagRow ids={flags} size="w-6" /><OpenTag tz={wing.tz} testid={`${testid}-open-tag`} /></div>
      <span className="font-mono-x text-xs">{label}</span>
    </div>
    <div>
      <p className="font-display text-5xl font-bold tracking-[-0.04em]">{wing.name}</p>
      <a href={`mailto:${wing.email}`} className="ul-draw font-display mt-5 block w-fit break-all text-xl font-semibold sm:text-3xl" data-testid={`${testid}-email`}>{wing.email}</a>
      <a href={`tel:${wing.tel}`} className="ul-draw font-mono-x mt-2 block w-fit text-lg" data-testid={`${testid}-phone`}>{wing.phone}</a>
      {children}
    </div>
  </FadeUp>
);

const FIELDS = [
  { name: "name", label: "your name", required: true },
  { name: "email", label: "email", type: "email", required: true },
  { name: "company", label: "company" },
  { name: "phone", label: "phone" },
  { name: "message", label: "what's on your mind", type: "textarea", span: 2, required: true },
];

export default function Contact() {
  return (
    <div data-testid="contact-page">
      <PageHero testid="contact-hero" eyebrow="contact" lines={["say the word.", "the clock", <span className="font-serif-i text-[#FF4D1A]">starts now.</span>]}
        aside={<HeroCard live tone="ink" caption="That's how long you've been here. Brief us now and we'll reply before this reaches one hour." testid="contact-hero-card" />}
        lead="Pick the wing closest to your team, or don't. Either one will get you an answer inside the hour." />
      <section className="px-5 pb-24 sm:px-8" data-testid="offices-section">
        <div className="mx-auto grid max-w-[1400px] gap-4 lg:grid-cols-12">
          <Office wing={WINGS.pitsus} flags={["us"]} label="pitsus.com" tone="bg-[#0E0E10] text-[#F1ECE2]" testid="office-us" className="lg:col-span-5">
            <address className="mt-6 not-italic leading-relaxed">{US_ADDRESS.map((l) => <span key={l} className="block">{l}</span>)}</address>
          </Office>
          <Office wing={WINGS.pitsind} flags={["uk", "eu", "apac"]} label="pitsind.com" tone="bg-[#FF4D1A] text-white" testid="office-in" className="lg:col-span-7 lg:mt-12">
            <address className="mt-6 not-italic leading-relaxed">{INDIA_ADDRESS.map((l) => <span key={l} className="block">{l}</span>)}</address>
          </Office>
        </div>
      </section>
      <section className="bg-[#E7E0D2] px-5 py-24 sm:px-8 lg:py-32" data-testid="contact-form-section">
        <div className="mx-auto grid max-w-[1400px] gap-14 lg:grid-cols-12">
          <div className="lg:col-span-4">
            <Eyebrow className="text-[#c2380f]">or write here</Eyebrow>
            <p className="font-display mt-6 text-4xl font-bold leading-[0.95] tracking-[-0.03em] sm:text-5xl">we'll route it to the <span className="font-serif-i">right wing.</span></p>
          </div>
          <div className="lg:col-span-7 lg:col-start-6"><EnquiryForm kind="contact" fields={FIELDS} regionLabel="where are you?" cta="send it" testid="contact-form" /></div>
        </div>
      </section>
    </div>
  );
}
